import { render, staticRenderFns } from "./Criar-Lembrete-Medicacao.vue?vue&type=template&id=70c890f0&scoped=true&"
import script from "./Criar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
export * from "./Criar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Lembrete-Medicacao.vue?vue&type=style&index=0&id=70c890f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c890f0",
  null
  
)

component.options.__file = "Criar-Lembrete-Medicacao.vue"
export default component.exports